const axios = require('axios');

module.exports = {

    sendEmail(name, position, companyName, email, telephone, content) {

        let form = new FormData();
        form.append("name", name);
        form.append("position", position);
        form.append("company_name", companyName);
        form.append("mail", email);
        form.append("tel", telephone);
        form.append("message", content);

        return axios.post(`contact/mail/contact.php`, form);
    },
};